import BbProxy from "@/proxies/BbProxy";

class MentionedUserdProxy extends BbProxy {
  constructor() {
    super("app/backoffice/managers");
  }
}

export default MentionedUserdProxy;
